import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const PageHeaderVisibilityContext = createContext({
  hasLocalPageHeader: false,
  registerLocalPageHeader: () => () => {},
});

export const PageHeaderVisibilityProvider = ({ children }) => {
  const [localPageHeaderCount, setLocalPageHeaderCount] = useState(0);

  const registerLocalPageHeader = useCallback(() => {
    setLocalPageHeaderCount((prev) => prev + 1);
    return () => {
      setLocalPageHeaderCount((prev) => (prev > 0 ? prev - 1 : 0));
    };
  }, []);

  const value = useMemo(
    () => ({
      hasLocalPageHeader: localPageHeaderCount > 0,
      registerLocalPageHeader,
    }),
    [localPageHeaderCount, registerLocalPageHeader]
  );

  return <PageHeaderVisibilityContext.Provider value={value}>{children}</PageHeaderVisibilityContext.Provider>;
};

PageHeaderVisibilityProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const usePageHeaderVisibility = () => useContext(PageHeaderVisibilityContext);

export default PageHeaderVisibilityContext;
